import styled from "styled-components";

export const AssessmentButtonTile = styled.div`
    opacity: 0;
    transition: opacity .5s ease-out;
    display: flex;
    background: #ffaf22;
    color: #fff;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 600;
    cursor: pointer;
    font-size: 8px;
    width: 75px;
    height: 20px;
    margin-top: 6px;

    @media(min-width: 768px){
        font-size: 12px;
        width: 100px;
        height: 25px;
        margin-top: 9px;
    }
    @media(min-width: 1024px){
        font-size: 16px;
        width: 150px;
        height: 40px;
        margin-top: 12px;
    }
`;

export const AssessmentCardBackgroundTile = styled.div`
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, rgba(43, 43, 43, 0) 36.99%, #2B2B2B 110.28%), url(${(props) => props.imgURL});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    transition: transform 0.5s ease-in-out;
`

export const AssessmentCardTitleAndButtonTile = styled.div`
    position: absolute;
    bottom: 0px;
    transform: translateY(15px);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.5s ease-in-out;

    @media (min-width: 768px) {
        transform: translateY(30px);
    }
    @media(min-width: 1024px){
        transform: translateY(45px);
    }
`

export const AssessmentCardContainerTile = styled.div`
    flex: 0 0 129px;
    height: 138px;
    margin-right: 30px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    &:hover {
        ${AssessmentCardBackgroundTile} {
            transform: scale(1.05);
        }
        ${AssessmentCardTitleAndButtonTile}{
            transform: translateY(-15px);
        }
        ${AssessmentButtonTile}{
            opacity: 1;
        }
    }
    
    @media(min-width: 768px){
        flex: 0 0 229px;
        height: 238px;
        margin-right: 60px;
        border-radius: 8px;
    }
    @media(min-width: 1024px){
        flex: 0 0 329px;
        height: 338px;
        margin-right: 90px;
        border-radius: 10px;
    }
`;

export const AssessmentCategoryTile = styled.div`
    
    background: rgba(0, 0, 0, 0.38);
    backdrop-filter: blur(14px);
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    width: fit-content;
    cursor: default;

    padding: 2px;
    border-radius: 16px;
    font-size: 10px;
    line-height: 8px;

    @media(min-width: 768px){
        padding: 4px;
        border-radius: 21px;
        font-size: 12px;
        line-height: 12px;
    }
    @media(min-width: 1024px){
        padding: 7px;
        border-radius: 28px;
        font-size: 16px;
        line-height: 16px;
    }
`;

export const AssessmentInfoSeparator = styled.div`
    background: #FFFFFF;
    height: 4px;
    width: 20px;
    margin: 5px 0px;
`;

export const AssessmentTitleTile = styled.div`
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    display: flex;
    justify-content: center;
    cursor: default;
    text-align: center;
    line-height: 1.1;

    width: 107px;
    font-weight: 600;
    font-size: 16px;
    @media(min-width: 768px){
        width: 187px;
        font-weight: 600;
        font-size: 21px;
    }
    @media(min-width: 1024px){
        width: 287px;
        font-weight: 600;
        font-size: 28px;
    }
`;